jQuery(function($) {

    $(function() {

        // Hide Reference sub-level filter unless References is active

        if ($(".field-referenssi").hasClass('active')){

            $(".reference-filter").removeClass( "hidden" );

        }

        // Add manual hover class to style selected button, since 'active' class can not be used for CSS

        $('.reference-filter .alm-filter--link').click(function() {
            $(this).addClass('hover');
            $('.reference-filter .alm-filter--link').not(this).removeClass('hover');
        });

    });

    $(document).click(function() {

        // Write down URL with parameters
        var uri = window.location.toString();

        // Hide Reference subfilter again on another filter click
        if ($(".field-referenssi").hasClass('active')){

            $(".reference-filter").removeClass( "hidden" );

        }

        else{

            $(".reference-filter").addClass("hidden");

            // Remove URL parameters when changing filter on top-level to wipe References sub filter from ALM listing
            if (uri.indexOf("&reference-type") > 0) {
                var clean_uri = uri.substring(0, uri.indexOf("&reference-type"));
                window.history.replaceState({}, document.title, clean_uri);
            }
            //url.split('?')[0];

        }

        // Remove Reference-taxonomy attributes from ALM listing //
        $("#ajax-load-more ul").removeData("taxonomy-terms");
        $("#ajax-load-more ul").removeData("taxonomy");
        $(".filter-reference-type .alm-filter--link").removeClass('active');
        $(".filter-reference-type .alm-filter--link").attr("aria-checked", "false");
    });

});


/*
document.addEventListener('DOMContentLoaded', function() {

    // Hide Reference sub-level filter unless References is active

    if (document.querySelector(".field-referenssi").classList.contains('active')){
        document.querySelector(".reference-filter").classList.remove( "hidden" );
    }

    // Add manual hover class to style selected button, since 'active' class can not be used for CSS

    document.querySelector('.reference-filter .alm-filter--link').click(function() {
        document.querySelector(this).classList.add('hover');
        document.querySelector('.reference-filter .alm-filter--link').not(this).classList.remove('hover');
    });

});

document.querySelector('.alm-filter--link').click(function() {

    // Write down URL with parameters
    var uri = window.location.toString();

    // Hide Reference subfilter again on another filter click
    if (document.querySelector(".field-referenssi").classList.contains('active')){

        document.querySelector(".reference-filter").classList.remove( "hidden" );

    }

    else{

        document.querySelector(".reference-filter").classList.add("hidden");

        // Remove URL parameters when changing filter on top-level to wipe References sub filter from ALM listing
        if (uri.indexOf("&reference-type") > 0) {
            var clean_uri = uri.substring(0, uri.indexOf("&reference-type"));
            window.history.replaceState({}, document.title, clean_uri);
        }
        //url.split('?')[0];

    }

    // Remove Reference-taxonomy attributes from ALM listing //
    document.querySelector("#ajax-load-more ul").removeData("taxonomy-terms");
    document.querySelector("#ajax-load-more ul").removeData("taxonomy");
    document.querySelector(".filter-reference-type .alm-filter--link").classList.remove('active');
    document.querySelector(".filter-reference-type .alm-filter--link").attr("aria-checked", "false");

});

*/




